import { boolean } from 'boolean'
import { Footer } from 'components/Footer'
import { Header, HeaderType } from 'components/Header'
import { DEFAULT_CATEGORY_SLUG, DEFAULT_ZONE_SLUG } from 'consts'
import { useCategoryQuery } from 'hooks/useCategoryQuery'
import { useUrl } from 'hooks/useUrl'
import { useZoneQuery } from 'hooks/useZoneQuery'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { findRole } from 'utils/role'
import { Search } from 'views/search'

const SearchPage: NextPage = () => {
  const { query } = useRouter()
  const url = useUrl()
  const isMap = boolean(url.query.map)

  const role = findRole(query.roleSlug)

  const categoryQuery = useCategoryQuery({
    variables: { query: query.categorySlug },
    skip: query.categorySlug === DEFAULT_CATEGORY_SLUG,
  })
  const category = categoryQuery.data?.category

  const zoneQuery = useZoneQuery({
    variables: { query: query.zoneSlug },
    skip: query.zoneSlug === DEFAULT_ZONE_SLUG,
  })
  const zone = zoneQuery.data?.zone

  if (categoryQuery.loading || zoneQuery.loading) {
    return null
  }

  return (
    <>
      <Header type={HeaderType.Search} {...{ role, category, zone }} />
      <Search {...{ role, category, zone }} />
      {!isMap && <Footer />}
    </>
  )
}

export default SearchPage
